import { PRIVACY_LINK, PROCESSING_LINK } from 'shared/constants/privacyPolicyLink';
import * as styles from './styles.css';
import { Button, Chips, FormField, NumberInput } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/symbols';

interface ISecondStepFormProps {
  chipsError?: string;
  selectedChips: string[];
  price?: number;
  priceError?: string;
  priceAdornment: string;
  isLoading: boolean;
  onBtnNext: VoidFunction;
  onChangePrice: (value: number) => void;
  onChangeSelectedChips: (value: string[]) => void;
}

export const SecondStepForm: React.FC<ISecondStepFormProps> = ({
  chipsError,
  selectedChips,
  price,
  priceError,
  priceAdornment,
  isLoading,
  onBtnNext,
  onChangePrice,
  onChangeSelectedChips,
}) => {
  return (
    <div>
      <FormField label="На какой срок сдаёте" errorMessage={chipsError}>
        <Chips
          value={selectedChips}
          onChange={onChangeSelectedChips}
          options={[
            { value: 'Посуточно', label: 'Посуточно' },
            { value: 'От года', label: 'От года' },
          ]}
        />
      </FormField>
      <FormField label="Желаемая арендная плата" errorMessage={priceError}>
        <NumberInput
          size="M"
          value={price}
          onChange={onChangePrice}
          rightAdornment={<div className={styles['right-adornment']}>₽/{priceAdornment}.</div>}
        />
      </FormField>
      <Button loading={isLoading} onClick={onBtnNext} fullWidth size="M">
        Дальше
      </Button>
      <div className={styles['notice']}>
        Нажимая «Дальше», я{NBSP}даю{NBSP}
        <a href={PROCESSING_LINK} className={styles['link']} target="_blank" rel="noreferrer">
          Согласие на обработку персональных данных
        </a>{' '}
        в{NBSP}соответствии с{' '}
        <a href={PRIVACY_LINK} className={styles['link']} target="_blank" rel="noreferrer">
          Политикой конфиденциальности.
        </a>
      </div>
    </div>
  );
};
